// Stub for optional @sentry/react-native Expo Router integration (not used in this app).
module.exports = { store: null }
